export default "__VITE_ASSET__5d071a2f__"